export class EditProfileModel {
    public userId: number;
    public name: string;
    public phone: string;
}